
export default function isBeforePriceRangeGroup(attributeGroup) {
    return attributeGroup.sort_order < 100;
}
